/**
 * Notifications feature auto-registration and exports
 *
 * This module automatically registers the notifications feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';
import { notificationsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(notificationsFeature);

// Export store (all store-related exports)
export * from './store';

// Export components
export * from './components';

// Export types
export * from './types';
